export const rules = {
  labels: [
    {
      required: true,
      message: '请输入标签名称',
      trigger: 'blur'
    },
    {
      validator: tagTextCountValidator
    }
  ],
  label: [
    {
      required: true,
      message: '请输入标签名称',
      trigger: 'blur'
    },
    {
      validator: tagTextCountValidator
    }
  ]
}

export const getAiTagRules = (formData) => {
  return {
    ...rules,
    parentId: [
      {
        validator(rule, value, callback) {
          if (formData.value.level > 1 && !value) {
            callback(new Error('请选择父标签'))
          }
          callback()
        }
      }
    ],
    labelDesc: [
      { max: 200, message: '标签描述最多200个字符', trigger: 'blur' }
    ],
    gameIds: [
      { required: true, message: '请选择游戏', trigger: 'change' },
      { type: 'array', min: 1, message: '请选择游戏', trigger: 'change' }
    ]
  }
}

function tagTextCountValidator(rule, value, callback) {
  if (value?.trim()) {
    const labels = value.split('\n')
    const isPass = labels.every((label) => label.length <= 100)
    if (!isPass) {
      callback(new Error('每个标签不超过100个字符'))
    }
    callback()
  } else {
    callback(new Error('请输入标签名称'))
  }
}
